<puro-modal
  [class]="modalCssClass()"
  [className]="modalCssClass()"
  [open]="open()"
  [title]="modalTitle()"
  size="medium"
  [showCloseButton]="false"
  [closeOnBackdrop]="true"
  [actions]="actions()"
  (closeModal)="onCancel()"
>
  <puro-typography component="p" variant="body1" [class]="bodyCssClass()">
    {{ bodyKey() | translate }}
  </puro-typography>
</puro-modal>
